// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"04741dec","429":"8577613e","453":"6803a592","923":"5da63dfc"}[chunkId] + ".chunk.js";
};